import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "py-2 px-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"min-width":"150px"} }
const _hoisted_4 = { class: "text-caption" }
const _hoisted_5 = { class: "text-caption font-weight-medium" }
const _hoisted_6 = { class: "text-caption" }
const _hoisted_7 = { class: "text-caption" }
const _hoisted_8 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_9 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_10 = { class: "text-caption" }
const _hoisted_11 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_12 = { class: "text-caption" }
const _hoisted_13 = { class: "text-caption" }
const _hoisted_14 = { class: "text-caption" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-caption" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-caption" }
const _hoisted_19 = { class: "text-caption" }
const _hoisted_20 = {
  key: 1,
  class: "text-caption text-red"
}
const _hoisted_21 = {
  key: 2,
  class: "text-caption"
}
const _hoisted_22 = {
  key: 3,
  class: "text-caption"
}

import { onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useOpportunitiesStore } from '@/store/opportunities';
import { usePreferencesStore } from '@/store/preferences';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/opportunities/opportunities.config';
import { useFloatFormStore } from '@/store/floatForm';


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  props: {
    id: {},
    onUpdate: { type: Function }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const opportunity = ref<any>(null); // puedes tiparlo como Opportunity si lo tienes importado
const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;

const preferencesStore = usePreferencesStore();
const opportunitiesStore = useOpportunitiesStore();

const allInteractions = ref<any[]>([]);
const selectedInteractionType = ref('Todo');

const selected_emails = ref<any[]>([]);

onMounted(async () => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map((val) => HEADERS.find((h:any) => h.value === val))
      .filter(Boolean) as typeof HEADERS
  );

  // 🔍 Cargar la oportunidad individual por ID
  const result = await opportunitiesStore.fetchOpportunityById(props.id + '?include=activities,quotations,sale,statuses');
  
  if (result) {
    const activities = result.activities.map((a: any) => ({ ...a, interaction_type: 'Actividad' }));
    const statuses = result.all_statuses.map((s: any) => ({ ...s, interaction_type: 'Status' }));
    const quotations = result.quotations.map((q: any) => ({ ...q, interaction_type: 'Cotización' }));
    const sale = result.sale ? [{ ...result.sale, interaction_type: 'Venta' }] : [];

    allInteractions.value = [...activities, ...statuses, ...quotations, ...sale].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    opportunity.value = result;
  }
});

const statusTime = computed(() => {
  if (!opportunity.value?.current_status?.created_at) return '';
  const from = new Date(opportunity.value.current_status.created_at);
  const now = new Date();
  const diff = Math.floor((now.getTime() - from.getTime()) / 3600000);
  return `${diff} horas`;
});

const groupedProductsByOrganization = computed(() => {
  const result: Record<string, any> = {};
  (opportunity.value?.products_of_interest || []).forEach((product: any) => {
    const orgId = product.organization.id;
    if (!result[orgId]) {
      result[orgId] = {
        organization: product.organization,
        products: [],
      };
    }
    result[orgId].products.push(product);
  });
  return Object.values(result);
});

const interactionTypes = computed(() => {
  return [
    { label: 'Todo', value: 'Todo', count: allInteractions.value.length },
    { label: 'Actividad', value: 'Actividad', count: allInteractions.value.filter(i => i.interaction_type === 'Actividad').length },
    { label: 'Status', value: 'Status', count: allInteractions.value.filter(i => i.interaction_type === 'Status').length },
    { label: 'Cotización', value: 'Cotización', count: allInteractions.value.filter(i => i.interaction_type === 'Cotización').length },
    { label: 'Venta', value: 'Venta', count: allInteractions.value.filter(i => i.interaction_type === 'Venta').length }
  ];
});

const filteredInteractions = computed(() => {
  if (selectedInteractionType.value === 'Todo') return allInteractions.value;
  return allInteractions.value.filter(i => i.interaction_type === selectedInteractionType.value);
});

const floatFormStore = useFloatFormStore();

const onUpdate = props?.onUpdate;

const editItem = (item: any) => {
  floatFormStore.openForm({
    component: 'EditForm',
    formTitle: 'Editar Oportunidad',
    formWidth: '1080',
    module: 'Opportunities',
    props: {
      item,
      onUpdate: onUpdate
    }
  });
};

const changeStatusToLose = async (item_id: any) => {
  if (onUpdate) {
    await onUpdate({id:item_id, status:'Oportunidad cerrada perdida'});
  } else {
      console.warn('[EditForm] No se proporcionó función onUpdate');
    }
};

const sendMediaKit = async (item_id: any) => {
  await opportunitiesStore.sendMediaKit({emails:selected_emails})
};


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_contactInfo = _resolveComponent("contactInfo")!
  const _component_leadInfo = _resolveComponent("leadInfo")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (opportunity.value!=undefined)
    ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, { class: "px-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                class: "elevation-0",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-keyboard-backspace")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(opportunity.value.opportunity_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_menu, null, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    icon: "",
                    class: "elevation-0"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-dots-vertical")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    "min-width": "300",
                    class: "px-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_subtitle, { class: "mt-4 mb-3" }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Acciones")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_list, { style: {"text-align":"right"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (editItem(opportunity.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode("Editar Oportunidad")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (editItem(opportunity.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("Enviar Media Kit")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeStatusToLose(opportunity.value.id)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode("Oportuniad Perdida")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("mdi-office-building-outline")
                          ])),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(opportunity.value?.subject?.attributes?.commercial_name || opportunity.value?.subject?.attributes?.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "x-small" }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode("mdi-information-variant-circle-outline")
                          ])),
                          _: 1
                        }),
                        _createTextVNode(" En " + _toDisplayString(opportunity.value?.current_status?.name) + " desde hace " + _toDisplayString(statusTime.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_spacer),
                  (opportunity.value?.subject?.type  == 'leads')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "#efddff",
                        label: "",
                        class: "mt-4"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" Lead ")
                        ])),
                        _: 1
                      }))
                    : (opportunity.value?.subject?.type  == 'clients')
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          color: "#c8dcff",
                          label: "",
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" Cliente ")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_chip, _mergeProps(props, {
                  link: "",
                  pill: "",
                  size: "x-small"
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      class: "pa-1",
                      start: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          style: {"border-radius":"50%!important"},
                          src: "https://ionicframework.com/docs/img/demos/avatar.svg"
                        })
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(opportunity.value?.user?.name + (opportunity.value?.user?.last_name!=null?(' ' + opportunity.value?.user?.last_name):'')), 1)
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_v_card_title, { class: "pl-0" }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("Interes(es)")
                  ])),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedProductsByOrganization.value, (group, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_component_v_row, { class: "ma-0 mb-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          size: "30px",
                          start: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: group?.organization?.logo_isotype
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_subtitle, { class: "py-1 px-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(group?.organization?.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product, idx) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        label: "",
                        key: idx,
                        class: "mr-2",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product.description), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                }), 128))
              ]),
              (opportunity.value.description!=null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("Descripción")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_card, { class: "elevation-0 pa-4" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(opportunity.value.description), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(_component_v_tabs, {
                  modelValue: selectedInteractionType.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedInteractionType).value = $event)),
                  "align-tabs": "center"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interactionTypes.value, (type, index) => {
                      return (_openBlock(), _createBlock(_component_v_tab, {
                        key: index,
                        value: type.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.label) + " (" + _toDisplayString(type.count) + ")", 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_v_row, { class: "ma-0 mt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_timeline, {
                        "truncate-line": "both",
                        align: "start",
                        side: "end"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredInteractions.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_v_timeline_item, {
                              size: "x-small",
                              key: index
                            }, {
                              opposite: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("strong", null, _toDisplayString(item?.interaction_type), 1),
                                  _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mr-1"
                                    }, {
                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                        _createTextVNode("mdi-calendar")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode(_toDisplayString(_ctx.$dateFormat((item.created_at || item.date).slice(0,10))) + " ", 1),
                                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mr-1"
                                    }, {
                                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                                        _createTextVNode("mdi-clock")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode(_toDisplayString(_ctx.$hourFormat((item.created_at || item.date).slice(11,20))), 1)
                                  ])
                                ])
                              ]),
                              default: _withCtx(() => [
                                (item?.interaction_type=='Status')
                                  ? (_openBlock(), _createBlock(_component_v_card, {
                                      key: 0,
                                      width: "600",
                                      class: "elevation-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_chip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (item.additional_data!=null&&item.additional_data!='null'&&item.additional_data.length>0)
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              class: "ma-0 mt-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_subtitle, null, {
                                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                    _createTextVNode("Evidencia:")
                                                  ])),
                                                  _: 1
                                                }),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.additional_data), (data, index) => {
                                                  return (_openBlock(), _createBlock(_component_v_btn, {
                                                    variant: "tonal",
                                                    size: "x-small",
                                                    key: index,
                                                    href: data.file,
                                                    target: "_blank"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        size: "small",
                                                        class: "mr-1"
                                                      }, {
                                                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                          _createTextVNode("mdi-download")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createTextVNode(" " + _toDisplayString(data.label), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["href"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (item.interaction_type === 'Actividad')
                                    ? (_openBlock(), _createBlock(_component_v_card, {
                                        key: 1,
                                        width: "600",
                                        class: "elevation-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_5, _toDisplayString(item.type), 1),
                                          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$dateFormat(item.only_date)) + " " + _toDisplayString(_ctx.$hourFormat(item.only_time)), 1),
                                          _createElementVNode("div", _hoisted_7, _toDisplayString(item.description), 1),
                                          (item.completed_at)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Se completó el " + _toDisplayString(_ctx.$dateFormat(item.completed_at.slice(0, 10))) + " a las " + _toDisplayString(_ctx.$hourFormat(item.completed_at.slice(11, 20))), 1))
                                            : _createCommentVNode("", true),
                                          (item.user)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.user.name) + " " + _toDisplayString(item.user.last_name), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (item.interaction_type === 'Cotización' || item.interaction_type === 'Venta')
                                      ? (_openBlock(), _createBlock(_component_v_card, {
                                          key: 2,
                                          width: "600",
                                          class: "elevation-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_10, "ID: " + _toDisplayString(item.id), 1),
                                            (item.user)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Vendedor: " + _toDisplayString(item.user.name) + " " + _toDisplayString(item.user.last_name), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_12, "Subtotal: " + _toDisplayString(_ctx.$toCurrency(item.subtotal)), 1),
                                            _createElementVNode("div", _hoisted_13, "IVA: " + _toDisplayString(_ctx.$toCurrency(item.iva)), 1),
                                            _createElementVNode("div", _hoisted_14, "Total: " + _toDisplayString(_ctx.$toCurrency(item.total)), 1),
                                            (item.needs_authorization)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                  _createElementVNode("div", _hoisted_16, "Total Sugerido: " + _toDisplayString(_ctx.$toCurrency(item.suggested_total)), 1),
                                                  (item.authorized_by)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                        _createElementVNode("div", _hoisted_18, " Autorizado el " + _toDisplayString(_ctx.$dateFormat(item.authorized_at.slice(0,10))) + " a las " + _toDisplayString(_ctx.$hourFormat(item.authorized_at.slice(11,20))), 1),
                                                        _createElementVNode("div", _hoisted_19, " Autorizado por " + _toDisplayString(item.authorized_by.name) + " " + _toDisplayString(item.authorized_by.last_name), 1)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_20, "Requiere Autorización"))
                                                ]))
                                              : _createCommentVNode("", true),
                                            (item.payment_method)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Método de pago: " + _toDisplayString(item.payment_method), 1))
                                              : _createCommentVNode("", true),
                                            (item.notes)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Notas: " + _toDisplayString(item.notes), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      (opportunity.value?.subject?.type == 'clients')
                        ? (_openBlock(), _createBlock(_component_contactInfo, {
                            key: 0,
                            style: _normalizeStyle(_ctx.device >= 768?'width:30%;':'display:none;'),
                            selected_client: opportunity.value?.subject
                          }, null, 8, ["style", "selected_client"]))
                        : _createCommentVNode("", true),
                      (opportunity.value?.subject?.type == 'leads')
                        ? (_openBlock(), _createBlock(_component_leadInfo, {
                            key: 1,
                            style: _normalizeStyle(_ctx.device >= 768?'width:30%;':'display:none;'),
                            selected_lead: opportunity.value?.subject
                          }, null, 8, ["style", "selected_lead"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})